import { useState } from "react";
import useAxios from "axios-hooks";

const useUnsubscribedUsersReport = () => {
  const [reportData, setReportData] = useState(null);

  const [{ loading, error }, fetchReport] = useAxios(
    { method: "GET" },
    { manual: true }
  );

  const generateReport = async (selectedCobrands, selectedSubusers) => {
    if (!selectedCobrands || selectedCobrands.length === 0) {
      return;
    }

    const subusersParam = selectedSubusers.map((s) => s.value).join(",");

    const cobrandIds = selectedCobrands
      .map((cobrand) => cobrand.coBrandId || cobrand.cobrandId || cobrand.CobrandId)
      .filter((id) => id != null)
      .join(",");

    if (!cobrandIds) {
      console.error("No cobrandIds found in selectedCobrands:", selectedCobrands);
      return;
    }

    try {
      const response = await fetchReport({
        url: `/emails/unsubscribes-report?cobrandIds=${cobrandIds}&subusers=${subusersParam}`,
      });
      setReportData(response.data);
    } catch (err) {
      console.error("Error fetching report:", err);
    }
  };

  const exportToCsv = (selectionInfo) => {
    if (!reportData) return;

    const csvRows = [];
    csvRows.push("Source,Email,Member ID,First Name,Last Name");

    if (reportData.databaseUnsubscribes?.users) {
      reportData.databaseUnsubscribes.users.forEach((user) => {
        csvRows.push(
          `Database,"${user.email}",${user.memberId || ''},"${user.firstName || ''}","${user.lastName || ''}"`
        );
      });
    }

    if (reportData.sendGridUnsubscribes?.users) {
      reportData.sendGridUnsubscribes.users.forEach((user) => {
        csvRows.push(
          `SendGrid,"${user.email}",${user.memberId || ''},"${user.firstName || ''}","${user.lastName || ''}"`
        );
      });
    }

    const csvContent = csvRows.join("\n");
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);

    const filenameLabel = selectionInfo?.name
      ? selectionInfo.name
          .replace(/[\\/:*?"<>|]/g, "")   // strip characters invalid in file names
          .replace(/\s+/g, "-")           // replace whitespace runs with a single hyphen
          .replace(/[^a-zA-Z0-9-_]/g, "") // strip any remaining non-safe characters
          .replace(/-{2,}/g, "-")         // collapse consecutive hyphens
          .replace(/^-+|-+$/g, "")        // trim leading/trailing hyphens
          || "report"
      : "report";

    link.setAttribute("href", url);
    link.setAttribute(
      "download",
      `unsubscribes-report-${filenameLabel}-${new Date().toISOString().split("T")[0]}.csv`
    );
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return {
    reportData,
    loading,
    error,
    generateReport,
    exportToCsv,
  };
};

export default useUnsubscribedUsersReport;
